import React, { useEffect } from 'react';

const { tableau } = window;
const TableauContainer = (props) => {
    const initViz = async () => {
        if (props.API) {
            await props.API.get(props.tokenurl).then(response => {
                if (response?.status === 200 && response?.data?.retdata) {
                    const options = {
                        hideToolbar: true,
                        hideTabs: true,
                        toolbarPosition: 'TOP'
                    };
                    let container = document.getElementById(props.elmId);
                    new tableau.Viz(container, props?.url?.replace('{token}', response.data.retdata, options));
                }
            });
        }
    };

    useEffect(() => {
        initViz();
        return () => {
            let vizs = tableau.VizManager.getVizs();
            for (let i = vizs.length; i > 0; i--) {
                vizs[i - 1].dispose();
            }
        }
    }, []);

    return (
        <div>
            <div id={props.elmId} style={{ width: '100wh', height: '100vh', display: 'flex', justifyContent: 'center', backgroundColor: '#f7f7f7' }}>
            </div>
        </div>
    );
}

export default TableauContainer;